(ns teamoesterreich.admin-mode.toe-map-list.maps-element
  (:require [reagent.core :as r]
            [teamoesterreich.view-state :as vstate]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.admin-mode.data.user :as s-user]
            ))




(defn get-update-map-content [!marker gmap search filter !selected]
  (js/console.log "get-update-map-content  .getBounds: " (.getBounds gmap))
  (when (and gmap (.getBounds gmap))
    (let [bounds (.getBounds gmap)
          ne (.getNorthEast bounds)
          sw (.getSouthWest bounds)

          query {:ne-lat (.lat ne)
                 :ne-lng (.lng ne)
                 :sw-lat (.lat sw)
                 :sw-lng (.lng sw)
                 :srch (or search "")
                 :srch-add-fields     {:tomId true :name true :email true :phone true}
                 :filter-status (:filter-status filter)  :filter-organizationDepartment (:filter-organizationDepartment filter)
                 :filter-organization (:filter-organization filter) :filter-toe-active (:filter-toe-active filter)
                 }
          ]
      (log/debug "get-update-map-content  : " (clj->js query) (count @!marker))
      (s-user/get-user-map-elements
        query
        (fn [elms]
          (doseq [[id m] @!marker]
            (.setMap m nil))
          (reset! !marker nil)
          (log/debug "set marker  : " (count elms) " sel " @!selected)
          (let [markers (reduce (fn [c [_ u]] (let [marker (js/google.maps.Marker.
                                                             (clj->js (if (= "u" (get u "type"))
                                                                        {:title (str (get u "vn") " " (get u "ln") " \n" )
                                                                         :position (js/google.maps.LatLng. (get u "lat") (get u "lng"))
                                                                         :id (get u "id")
                                                                         :icon (if (= @!selected (get u "id")) "/custom/img/tmann16_sel.png"  "/custom/img/tmann16.png")
                                                                         }

                                                                        {:title (str (get u "cnt") " Personen" )
                                                                         :position (js/google.maps.LatLng. (get u "lat") (get u "lng"))
                                                                         :id (get u "id")
                                                                         :label {:color "#000" :fontSize "12px", :fontWeight "600" :text (str (get u "cnt"))}
                                                                         :icon  "/custom/img/cluster32.png" })))]
                                                (.setMap marker gmap)
                                                (when (= "u" (get u "type")) (js/google.maps.event.addListener marker "click" #(swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] (get u "id"))))
                                                (assoc c (get u "id") marker)
                                                ))
                                {}
                                elms
                                )]
            ;(log/debug "markers" markers)
            (reset! !marker markers)))
        ))))






(defn gmap-component [!st]
  (let [!search (r/cursor !st [:search])
        !centerMap (r/cursor !st [:center-map])
        !filter (r/cursor !st [:filter])
        !selected (r/cursor !st [:selected])
        !marker (atom {})
        ]
    ;(log/debug "Mount gmap " @!search @!filter )
    (let [gmap    (atom nil)
          options (clj->js {"center" vstate/MAP_CENTER
                            "zoom" vstate/MAP_ZOOM })
          update  (fn [& [parm parm2 new]]
                    (log/debug "UPDATE !centerMap?"  (clj->js parm) (clj->js parm2) " NEW: " (clj->js new))
                    (when (and new (:center-map new) (not-empty (:center-map new)))
                      (.setCenter (:map @gmap) (js/google.maps.LatLng. (:lat (:center-map new)) (:lng (:center-map new))))
                      (.setZoom (:map @gmap) (:zoom (:center-map new)))
                      (reset! !centerMap {})
                      )
                    (if new
                      (get-update-map-content !marker (:map @gmap) (:search new) (:filter new) !selected)
                      (get-update-map-content !marker (:map @gmap) @!search @!filter !selected)
                    ))]


      ;(update)
      (add-watch !st :atom-change
                 (fn [k r o n]
                   ;(log/debug "Watch trigger called" k  o "->" n)
                   (when (or
                            (not= (:filter o) (:filter n))
                            (not= (:search o) (:search n))
                            (and (:center-map n) (not-empty (:center-map n)) (not= (:center-map o) (:center-map n)))
                           )
                     (when (:map @gmap)
                       (log/debug "Watch trigger fired" n)
                       (update {} {} n)))))

      ;(add-watch !search :search-change (fn [k r o n]  (when (:map @gmap) (log/debug "Watch trigger !search" n) (update {}))))

      ;;(add-watch !centerMap :centerMap-change (fn [k r o n] (log/debug "Watch trigger !centerMap" n)))

      ;(log/debug "Mount gmap watcher registered " @!search @!filter @!centerMap)


      (r/create-class
        {:reagent-render (fn []
                           @!search
                           [:div#map-canvas {:style {:height "573px"}}])
         :component-did-mount (fn [comp]
                                (let [canvas  (.getElementById js/document "map-canvas")
                                      gm      (js/google.maps.Map. canvas options)]
                                  (reset! gmap {:map gm})
                                  (js/google.maps.event.addListener gm "dragend" update)
                                  (js/google.maps.event.addListener gm "zoom_changed" update)
                                  )

                                )
         :component-did-update #(update)
         :display-name "gmap-component"}))))

(def map-home gmap-component)
